import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Data } from "../../helpers";
import { DashboardService } from "../../dashboard";
import { PaymentHelper } from "../commons/helper/payment";
import { LoginService } from "../../login";
var UpgradePlanComponent = /** @class */ (function () {
    function UpgradePlanComponent(data, paymentHelper, dashboardService, router, loginService) {
        this.data = data;
        this.paymentHelper = paymentHelper;
        this.dashboardService = dashboardService;
        this.router = router;
        this.loginService = loginService;
        this.payPalId = "";
        this.upgradeData = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.acceptTC = false;
        this.popUp = false;
        this.loading = false;
        this.countryArr = {};
        this.planDetails = { payPalMonthlyId: "", payPalYearlyId: "" };
        this.subscriptions = [];
        this.validationReq = {
            tcReq: false,
            firstNameReq: false,
            lastNameReq: false,
            streetReq: false,
            cityReq: false,
            zipReq: false,
            countryReq: false,
            stateReq: false
        };
        if (this.data.storage == undefined) {
            this.router.navigate(["dashboard/upgrade"]);
        }
        else {
            this.payPalId = this.data.storage.payPalId;
            this.planDetails = this.data.storage.plan;
        }
    }
    UpgradePlanComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    UpgradePlanComponent.prototype.ngOnInit = function () {
        var _this = this;
        document.documentElement.scrollTop = 0;
        this.countryArr = this.paymentHelper.paypalCountries();
        //call the loginService
        var s1 = this.dashboardService.userSummary1().subscribe(function (data) {
            //console.log('usersummary', data);
            _this.upgradeData.firstName = data.firstName;
            _this.upgradeData.lastName = data.lastName;
        }, function (error) { console.log(error); });
        this.subscriptions.push(s1);
        var s2 = this.loginService.userCountry().subscribe(function (result) {
            var country_name = result.country_name;
            console.log("user country " + country_name);
            for (var i = 0, len = _this.countryArr.length; i < len; i++) {
                var country = _this.countryArr[i];
                //check name and user country name
                if (country.name.toUpperCase() === country_name.toUpperCase()) {
                    _this.upgradeData.country = country.code;
                    console.log("Loop is going to break. for " + country_name);
                    break;
                }
            }
        }, function (error) {
            console.log("user country retrieval service failed!!! with " + error);
        });
        this.subscriptions.push(s2);
    };
    UpgradePlanComponent.prototype.creditCardAction = function () {
        var _this = this;
        if (this.acceptTC == false) {
            this.msgTitle = "Validation Error!!";
            this.msgContent = "Please accept the Terms & Conditions";
            this.popUp = true;
            return;
        }
        this.loading = true;
        this.upgradeData.paypalId = this.payPalId.toString();
        this.upgradeData.type = this.getCreditCardType(this.upgradeData.cardNumber);
        var url = location.href;
        this.upgradeData.cancelUrl = url.replace("upgradeplan", "upgrade?payment=cancel");
        this.upgradeData.returnUrl = url.replace("upgradeplan", "upgrade?payment=success");
        console.log(this.upgradeData);
        this.dashboardService.upgradePlanCC(this.upgradeData).subscribe(function (data) {
            console.log(data);
            _this.loading = false;
            if (data.success == false) {
                _this.msgTitle = "Error!!";
                _this.msgContent = data.error;
                _this.popUp = true;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
            _this.loading = false;
        });
    };
    UpgradePlanComponent.prototype.checkNullOrEmpty = function (field) {
        if (field == null || field == "")
            return true;
        else
            return false;
    };
    UpgradePlanComponent.prototype.payPalAction = function () {
        //console.log("this.upgradeData", this.upgradeData);
        // if (this.acceptTC == false) {
        //   this.tcReq = true;
        //   this.msgTitle = "Validation Error!!";
        //   this.msgContent = "Please accept the Terms & Conditions";
        //   this.popUp = true;
        //   return;
        var _this = this;
        // }
        var errMsg = "";
        if (this.acceptTC == false) {
            errMsg += "<li>TC Reuired</li>";
            this.validationReq.tcReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.firstName)) {
            errMsg += "<li>First name is required.</li>";
            this.validationReq.firstNameReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.lastName)) {
            errMsg += "<li>Last name is required.</li>";
            this.validationReq.lastNameReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.street)) {
            errMsg += "<li>Street is required.</li>";
            this.validationReq.streetReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.city)) {
            errMsg += "<li>City is required.</li>";
            this.validationReq.cityReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.zip)) {
            errMsg += "<li>Zip is required.</li>";
            this.validationReq.zipReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.country)) {
            errMsg += "<li>Country is required.</li>";
            this.validationReq.countryReq = true;
        }
        if (this.checkNullOrEmpty(this.upgradeData.state)) {
            errMsg += "<li>State is required.</li>";
            this.validationReq.stateReq = true;
        }
        if (errMsg != "") {
            // this.msgTitle = "Validation Error!!";
            // this.msgContent = errMsg;
            // this.popUp = true;
            return;
        }
        this.loading = true;
        this.upgradeData.paypalId = this.payPalId.toString();
        var url = location.href;
        this.upgradeData.cancelUrl = url.replace("upgradeplan", "upgrade?payment=cancel");
        this.upgradeData.returnUrl = url.replace("upgradeplan", "upgrade?payment=success");
        console.log(this.upgradeData);
        this.dashboardService.upgradePlanPaypal(this.upgradeData).subscribe(function (data) {
            console.log(data);
            if (data.success == true) {
                window.location.href = data.launch_url;
            }
            else {
                _this.msgTitle = "Error!!";
                _this.msgContent = data.error;
                _this.popUp = true;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
            _this.loading = false;
        });
    };
    UpgradePlanComponent.prototype.getCreditCardType = function (number) {
        //start without knowing the credit card type
        var re = new RegExp("^4");
        if (number.match(re) != null)
            return "visa";
        // Mastercard
        // Updated for Mastercard 2017 BINs expansion
        if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
            return "mastercard";
        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null)
            return "amex";
        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) != null)
            return "discover";
        // Diners
        re = new RegExp("^36");
        if (number.match(re) != null)
            return "diners";
        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if (number.match(re) != null)
            return "diners";
        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (number.match(re) != null)
            return "jcb";
        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (number.match(re) != null)
            return "visa";
        return "";
    };
    UpgradePlanComponent.prototype.validateCardNumber = function () {
        if (this.upgradeData.cardNumber === undefined ||
            this.upgradeData.cardNumber === "") {
            console.log("no need to validate an empty creditcard");
            return;
        }
        if (!this.paymentHelper.isValid(this.upgradeData.cardNumber)) {
            this.loading = false;
            this.msgTitle = "Error!!";
            this.msgContent = "Invalid Creditcard Number, please check the number";
            this.popUp = true;
        }
        else {
            this.upgradeData.type = this.getCreditCardType(this.upgradeData.cardNumber);
            if (this.upgradeData.type == "") {
                this.loading = false;
                this.msgTitle = "Error!!";
                this.msgContent = "Invalid Creditcard Number, please check the number";
                this.popUp = true;
            }
        }
    };
    UpgradePlanComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return UpgradePlanComponent;
}());
export { UpgradePlanComponent };
//# sourceMappingURL=upgradeplan.component.js.map